import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import CustomerChurnReport from './layouts/CustomerChurnReport'

const CustomerChurnReportPageCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
]

const CustomerChurnReportPage = () => {
  return (
    <Navigation
      baseUrl='/analytics/customer-churn'
      breadcrumbs={CustomerChurnReportPageCrumbs}
      defaultKey='customer-churn'
      navigationData={[
        {
          key: 'customer-churn',
          label: 'Customer Churn',
          component: <CustomerChurnReport />,
        },
      ]}
    />
  )
}

export default CustomerChurnReportPage
